<page-header title="MAP"></page-header>
<card>
  <ng-select
    [items]="streets"
    name="streetId"
    [multiple]="false"
    [closeOnSelect]="true"
    (change)="onStreetChange($event?.id)"
    bindLabel="name"
    bindValue="id"
    [placeholder]="'SEARCH_STREET' | translate"
    [typeahead]="onStreetAutocomplete$"
    [(ngModel)]="streetId"
    style="width: 250px"
    (clear)="onStreetClear()"
  >
  </ng-select>
  <preview-map></preview-map>
</card>
